/** Uppercase the first letter in each line of Russian learner text. */
export function capitalizeRussianText(text: string): string {
  if (!text.trim()) {
    return "";
  }
  return text
    .split("\n")
    .map((line) => {
      const chars = [...line];
      for (let i = 0; i < chars.length; i += 1) {
        const ch = chars[i]!;
        if (/\p{L}/u.test(ch)) {
          chars[i] = ch.toLocaleUpperCase("ru-RU");
          break;
        }
      }
      return chars.join("");
    })
    .join("\n");
}

export function normalizeRussianTranslation(text: string, rowType: number): string {
  if (rowType === 7 || !text.trim()) {
    return text.trim() ? text : "";
  }
  return capitalizeRussianText(text);
}
